import {DomainAncestor, entityConfig} from "../../../core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {ID} from "../../../core/metamodel/metaConstant";
import {EnergyCarrier} from "../material/energyCarrierDomain";
import {LovItem} from "../../../core/metamodel/mdEntity";

@entityConfig()
export class ProjectVersionEnergyCarrier extends DomainAncestor {

  @observable energyCarrierId: number;
  @observable name: string;

  @observable energyConversionFactor: number;
  @observable co2Equivalent: number;
  @observable so2Equivalent: number;
  @observable noxEquivalent: number;
  @observable energyConsumption: number;

  @observable type : LovItem<ENERGYCARRIERTYPE>

  @observable originalEnergyCarrier: EnergyCarrier
  @observable projectVersion : LovItem

  @observable isCustom : boolean

  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.energyCarrierId;
  }

  public setId(id: ID): void {
    this.energyCarrierId = <number>id;
  }
}

export enum ENERGYCARRIERTYPE {
  HEATING = "HEATING",
  VENTILATION = "VENTILATION",
  COOLING = "COOLING",
  HUMIDITY = "HUMIDITY",
  LIGHTING = "LIGHTING",
  HOT_WATER = "HOT_WATER",
  AUXILIARY = "AUXILIARY"
}



// WEBPACK FOOTER //
// ./src/sbtool/domain/project/projectVersionEnergyCarrierDomain.ts